import React from 'react';
import { Helmet } from 'react-helmet-async';

const description = 'RPS Chaos 是由 Homy Tech 打造的免費互動式剪刀石頭布物理模擬器，讓訪客即時觀看 66 個石頭、剪刀與布角色在確定性混沌引擎中碰撞、轉換陣營並決出勝負，同時追蹤每局存活數量、勝率、累積回合與冠軍紀錄，適合用來探索競爭規則、隨機運動及混沌系統的視覺化結果。';

const SeoHead = () => {
  return (
    <Helmet>
      <title>✊🏼 ✂️ 🖐 大亂鬥 | Homy Tech</title>
      <meta name="description" content={description} />
      <meta name="author" content="Homy Tech" />
      <meta
        name="robots"
        content="index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1"
      />
      <meta property="article:published_time" content="2026-03-07" />
      <meta property="article:modified_time" content="2026-03-07" />
      <link rel="canonical" href="https://rps.homy.hk/" />
      <meta property="og:title" content="✊🏼 ✂️ 🖐 大亂鬥 | RPS Chaos" />
      <meta property="og:description" content={description} />
      <meta property="og:url" content="https://rps.homy.hk/" />
    </Helmet>
  );
};

export default SeoHead;